module.exports = __webpack_public_path__ + "static/media/camera.b7a51d12.png";